module.exports = __webpack_public_path__ + "img/singular-rank-logo-horizontal.5c8a8cdb.svg";